import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SeleccionarPacienteComponent } from './seleccionar-paciente.component';
import { PageHeaderModule } from '../../../shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material';
import { MatFormFieldModule, MatSelectModule } from '@angular/material';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AddPacienteModule } from '../add-paciente/add-paciente.module';

@NgModule({
    imports: [CommonModule,
        TranslateModule,
        PageHeaderModule,
        ReactiveFormsModule,
        FormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        NgxMatSelectSearchModule,
        AddPacienteModule,
        MatSelectModule],
        exports: [SeleccionarPacienteComponent],
    declarations: [SeleccionarPacienteComponent]
})
export class SeleccionarPacienteModule {}
